'use strict';

var cov_13iq2atie9 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/tree-view-structure/tree-view-structure.component.js',
      hash = 'a7a7025c3de45735824ac89d280eedf2bf5eadc1',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/tree-view-structure/tree-view-structure.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 27
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 84
        }
      },
      '4': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      '5': {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 26,
          column: 24
        }
      },
      '6': {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 24
        }
      },
      '7': {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 28,
          column: 25
        }
      },
      '8': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 42
        }
      },
      '9': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 47,
          column: 7
        }
      },
      '10': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 37,
          column: 8
        }
      },
      '11': {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 46,
          column: 7
        }
      },
      '12': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      '13': {
        start: {
          line: 41,
          column: 10
        },
        end: {
          line: 41,
          column: 46
        }
      },
      '14': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 58
        }
      },
      '15': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 49
        }
      },
      '16': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '17': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 60,
          column: 7
        }
      },
      '18': {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 11
        }
      },
      '19': {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 44
        }
      },
      '20': {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 59,
          column: 11
        }
      },
      '21': {
        start: {
          line: 58,
          column: 10
        },
        end: {
          line: 58,
          column: 65
        }
      },
      '22': {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 21
        }
      },
      '23': {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 23
        }
      },
      '24': {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      '25': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      '26': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 78,
          column: 9
        }
      },
      '27': {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 77,
          column: 37
        }
      },
      '28': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 35
        }
      },
      '29': {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      '30': {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 83
        }
      },
      '31': {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 28
        }
      },
      '32': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 22
        }
      },
      '33': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 55
        }
      },
      '34': {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      '35': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 94
        }
      },
      '36': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 34
        }
      },
      '37': {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 28
        }
      },
      '38': {
        start: {
          line: 112,
          column: 30
        },
        end: {
          line: 112,
          column: 87
        }
      },
      '39': {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      '40': {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 58
        }
      },
      '41': {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 48
        }
      },
      '42': {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 28
        }
      },
      '43': {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 130,
          column: 7
        }
      },
      '44': {
        start: {
          line: 138,
          column: 23
        },
        end: {
          line: 138,
          column: 56
        }
      },
      '45': {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 72
        }
      },
      '46': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 39
        }
      },
      '47': {
        start: {
          line: 145,
          column: 23
        },
        end: {
          line: 145,
          column: 69
        }
      },
      '48': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 72
        }
      },
      '49': {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 39
        }
      },
      '50': {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 152,
          column: 5
        }
      },
      '51': {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 83
        }
      },
      '52': {
        start: {
          line: 157,
          column: 0
        },
        end: {
          line: 166,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 45
          },
          end: {
            line: 6,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 12
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 64,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 32,
            column: 17
          },
          end: {
            line: 32,
            column: 18
          }
        },
        loc: {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 47,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 49,
            column: 23
          }
        },
        loc: {
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 61,
            column: 5
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 53,
            column: 22
          }
        },
        loc: {
          start: {
            line: 53,
            column: 30
          },
          end: {
            line: 55,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 57,
            column: 21
          },
          end: {
            line: 57,
            column: 22
          }
        },
        loc: {
          start: {
            line: 57,
            column: 30
          },
          end: {
            line: 59,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 37
          },
          end: {
            line: 91,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 105,
            column: 3
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 41
          },
          end: {
            line: 121,
            column: 3
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 21
          },
          end: {
            line: 131,
            column: 3
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 26
          },
          end: {
            line: 141,
            column: 3
          }
        }
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 36
          },
          end: {
            line: 153,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 41
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 41
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }]
      },
      '4': {
        loc: {
          start: {
            line: 71,
            column: 24
          },
          end: {
            line: 71,
            column: 35
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 71,
            column: 31
          },
          end: {
            line: 71,
            column: 35
          }
        }]
      },
      '5': {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }]
      },
      '6': {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }]
      },
      '7': {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 26
          }
        }, {
          start: {
            line: 76,
            column: 30
          },
          end: {
            line: 76,
            column: 59
          }
        }]
      },
      '8': {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }]
      },
      '9': {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }]
      },
      '10': {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }]
      },
      '11': {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    b: {
      '0': [0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeViewStructureComponent = function () {
  function TreeViewStructureComponent($log, $state, $filter, lodash) {
    _classCallCheck(this, TreeViewStructureComponent);

    ++cov_13iq2atie9.f[0];
    ++cov_13iq2atie9.s[0];

    this.$log = $log;
    ++cov_13iq2atie9.s[1];
    this.$filter = $filter;
    ++cov_13iq2atie9.s[2];
    this.lodash = lodash;
  }

  _createClass(TreeViewStructureComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_13iq2atie9.f[1];
      ++cov_13iq2atie9.s[3];

      // types de structures.
      this.types = this.lodash.uniqBy(this.lodash.map(this.structures, 'type'), 'id');
      // treeview
      ++cov_13iq2atie9.s[4];
      this.treeview = {
        data: this.displayStructuresWithTreeView(this.structures),
        rawData: this.structures,
        selected: [],
        search: '',
        selectAll: false
      };
    }

    /**
     * affichage des structures en arbre.
     */

  }, {
    key: 'displayStructuresWithTreeView',
    value: function displayStructuresWithTreeView() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_13iq2atie9.b[0][0], []);
      ++cov_13iq2atie9.f[2];

      var nodesTree = (++cov_13iq2atie9.s[5], []);
      var heritages = (++cov_13iq2atie9.s[6], []);
      var nodesTable = (++cov_13iq2atie9.s[7], []);

      ++cov_13iq2atie9.s[8];
      data = this.lodash.uniqBy(data, 'id');

      ++cov_13iq2atie9.s[9];
      data.forEach(function (structure) {
        ++cov_13iq2atie9.f[3];
        ++cov_13iq2atie9.s[10];

        nodesTable[structure.id] = {
          name: structure.name,
          id: structure.id,
          children: []
        };

        ++cov_13iq2atie9.s[11];
        if (structure.parent) {
          ++cov_13iq2atie9.b[1][0];
          ++cov_13iq2atie9.s[12];

          if (!heritages[structure.parent.id]) {
            ++cov_13iq2atie9.b[2][0];
            ++cov_13iq2atie9.s[13];

            heritages[structure.parent.id] = [];
          } else {
            ++cov_13iq2atie9.b[2][1];
          }
          ++cov_13iq2atie9.s[14];
          heritages[structure.parent.id].push(structure.id);
        } else {
          ++cov_13iq2atie9.b[1][1];
          ++cov_13iq2atie9.s[15];

          nodesTree.push(nodesTable[structure.id]);
        }
      });
      // console.log(heritages);
      ++cov_13iq2atie9.s[16];
      heritages.forEach(function (node, nodeIndex) {
        ++cov_13iq2atie9.f[4];
        ++cov_13iq2atie9.s[17];

        // nodes[nodeIndex].children = node;
        if (!nodesTable[nodeIndex]) {
          ++cov_13iq2atie9.b[3][0];
          ++cov_13iq2atie9.s[18];

          // heritages[nodeIndex].forEach()
          node.forEach(function (child) {
            ++cov_13iq2atie9.f[5];
            ++cov_13iq2atie9.s[19];

            nodesTree.push(nodesTable[child]);
          });
        } else {
          ++cov_13iq2atie9.b[3][1];
          ++cov_13iq2atie9.s[20];

          node.forEach(function (child) {
            ++cov_13iq2atie9.f[6];
            ++cov_13iq2atie9.s[21];

            nodesTable[nodeIndex].children.push(nodesTable[child]);
          });
        }
      });

      ++cov_13iq2atie9.s[22];
      return nodesTree;
    }

    /**
     * Récupérer les structures en fonction du type sélectionné.
     * @type {[type]}
     */

  }, {
    key: 'getStructuresFromType',
    value: function getStructuresFromType() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_13iq2atie9.b[4][0], null);
      ++cov_13iq2atie9.f[7];

      var structures = (++cov_13iq2atie9.s[23], []);

      ++cov_13iq2atie9.s[24];
      if (type !== null) {
        ++cov_13iq2atie9.b[5][0];
        ++cov_13iq2atie9.s[25];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.structures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var structure = _step.value;
            ++cov_13iq2atie9.s[26];

            if ((++cov_13iq2atie9.b[7][0], structure.type) && (++cov_13iq2atie9.b[7][1], structure.type.id === type.id)) {
              ++cov_13iq2atie9.b[6][0];
              ++cov_13iq2atie9.s[27];

              structures.push(structure);
            } else {
              ++cov_13iq2atie9.b[6][1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        ++cov_13iq2atie9.b[5][1];
        ++cov_13iq2atie9.s[28];

        structures = this.structures;
      }

      ++cov_13iq2atie9.s[29];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[8][0];
        ++cov_13iq2atie9.s[30];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(structures, 'id'));
      } else {
        ++cov_13iq2atie9.b[8][1];
      }

      ++cov_13iq2atie9.s[31];
      this.emitSelectedData();

      ++cov_13iq2atie9.s[32];
      return structures;
    }

    // sélectionnez toutes les structures de l'arbre

  }, {
    key: 'selectAllDataFromTreeview',
    value: function selectAllDataFromTreeview() {
      ++cov_13iq2atie9.f[8];
      ++cov_13iq2atie9.s[33];

      // cocher la case.
      this.treeview.selectAll = !this.treeview.selectAll;

      ++cov_13iq2atie9.s[34];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[9][0];
        ++cov_13iq2atie9.s[35];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(this.treeview.rawData, 'id'));
      } else {
        ++cov_13iq2atie9.b[9][1];
        ++cov_13iq2atie9.s[36];

        this.treeview.selected = [];
      }

      ++cov_13iq2atie9.s[37];
      this.emitSelectedData();
    }

    /**
     * Sélectionnez une structure dans l'arbre
     */

  }, {
    key: 'selectStructureFromTreeView',
    value: function selectStructureFromTreeView(structure) {
      ++cov_13iq2atie9.f[9];

      var hasStructureIndex = (++cov_13iq2atie9.s[38], this.lodash.indexOf(this.treeview.selected, structure.id));

      ++cov_13iq2atie9.s[39];
      if (hasStructureIndex >= 0) {
        ++cov_13iq2atie9.b[10][0];
        ++cov_13iq2atie9.s[40];

        this.treeview.selected.splice(hasStructureIndex, 1);
      } else {
        ++cov_13iq2atie9.b[10][1];
        ++cov_13iq2atie9.s[41];

        this.treeview.selected.push(structure.id);
      }

      ++cov_13iq2atie9.s[42];
      this.emitSelectedData();
    }

    /**
     * Emit parent component.
     */

  }, {
    key: 'emitSelectedData',
    value: function emitSelectedData() {
      ++cov_13iq2atie9.f[10];
      ++cov_13iq2atie9.s[43];

      this.onChange({
        value: this.treeview.selected
      });
    }

    /**
     * LISTENERS.
     */

  }, {
    key: 'listenTypeChange',
    value: function listenTypeChange(value) {
      ++cov_13iq2atie9.f[11];

      var structures = (++cov_13iq2atie9.s[44], this.getStructuresFromType(value));
      ++cov_13iq2atie9.s[45];
      this.treeview.data = this.displayStructuresWithTreeView(structures);
      ++cov_13iq2atie9.s[46];
      this.treeview.rawData = structures;
    }
  }, {
    key: 'listenSearchTreeviewChange',
    value: function listenSearchTreeviewChange(value) {
      ++cov_13iq2atie9.f[12];

      // TODO Reset Types de structure.
      var structures = (++cov_13iq2atie9.s[47], this.$filter('filter')(this.structures, value));
      ++cov_13iq2atie9.s[48];
      this.treeview.data = this.displayStructuresWithTreeView(structures);
      // raw data
      ++cov_13iq2atie9.s[49];
      this.treeview.rawData = structures;

      ++cov_13iq2atie9.s[50];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[11][0];
        ++cov_13iq2atie9.s[51];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(structures, 'id'));
      } else {
        ++cov_13iq2atie9.b[11][1];
      }
    }
  }]);

  return TreeViewStructureComponent;
}();

++cov_13iq2atie9.s[52];


angular.module('app').component('treeViewStructure', {
  bindings: {
    structures: '<',
    onChange: '&'
  },
  templateUrl: 'app/dashboard/tree-view-structure/tree-view-structure.template.html',
  controller: TreeViewStructureComponent
});